module.exports = __webpack_public_path__ + "img/01.e63c8105.jpg";